export type ChangeDetail = {
    value: string;
    checked: boolean;
    name: string | null;
};
